export { default as component } from "../../../../src/routes/(registration)/+layout.svelte";